import styled from "styled-components";
import { Col, Typography } from "antd";

export const StyledFooterBrand = styled(Col)``;

export const BrandHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 1%;
`;

export const BrandLogo = styled.img`
  width: 7%;
  height: auto;
`;

export const BrandTitle = styled(Typography.Title)`
  && {
    color: white;
    font-size: 1.5em;
    padding: 1%;
    margin: 0;
  }
`;

export const BrandParagraph = styled(Typography.Paragraph)`
  && {
    color: white;
    padding-top: 1%;
  }
`;
